import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import {
  FullLayoutComponent
} from './containers';
import { AuthComponent } from './components/auth/auth.component';
import {PeticionesComponent} from "./components/peticiones/peticiones.component";
import {AuthLayoutComponent} from "./containers/auth-layout/auth-layout.component";

export const routes: Routes = [
  {
    path: 'auth',
    component: AuthLayoutComponent,
    data: {
      title: 'Auth'
    },
    loadChildren: './module/auth/auth.module#AuthModule',
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'Evex'
    },
    children:[
      {
        path: 'solicitudes-usuario',
        loadChildren: './module/peticiones/peticiones.module#PeticionesModule',
      },
      {
        path: 'usuario',
        loadChildren: './module/usuario/usuario.module#UsuarioModule',
      },
      {
        path: 'transacciones',
        loadChildren: './module/transacciones/transacciones.module#TransaccionesModule',
      },
      {
        path: 'administrador',
        loadChildren: './module/administrador/administrador.module#AdministradorModule',
      }
    ]
  },

];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
